import { useEffect, useState } from "react";
export function useOnLineStatus() {
  const {
    0: onLine,
    1: setOnLine
  } = useState(true);
  useEffect(() => {
    let timeoutId;
    setOnLine(window.navigator.onLine);
    const listener = () => {
      timeoutId = setTimeout(() => {
        setOnLine(window.navigator.onLine);
      }, window.navigator.onLine ? 1 : 100);
    };
    window.addEventListener("online", listener);
    window.addEventListener("offline", listener);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("online", listener);
      window.removeEventListener("offline", listener);
    };
  }, []);
  return onLine;
}